/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PropertyStatusItemDto,
} from '../models/index';
import {
    PropertyStatusItemDtoFromJSON,
    PropertyStatusItemDtoToJSON,
} from '../models/index';

export interface PropertyControllerGetAssetRequest {
    filename: string;
}

export interface PropertyControllerGetListingByIdRequest {
    listingId: string;
}

export interface PropertyControllerGetListingByIdWithAgentBrandingRequest {
    propertyId: string;
    agentSlug: string;
    activeListing: string;
}

export interface PropertyControllerGetPropertyByIdRequest {
    propertyId: string;
    activeListing?: string;
}

/**
 * PropertyApi - interface
 * 
 * @export
 * @interface PropertyApiInterface
 */
export interface PropertyApiInterface {
    /**
     * 
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApiInterface
     */
    propertyControllerGetAssetRaw(requestParameters: PropertyControllerGetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    propertyControllerGetAsset(requestParameters: PropertyControllerGetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} listingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApiInterface
     */
    propertyControllerGetListingByIdRaw(requestParameters: PropertyControllerGetListingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    propertyControllerGetListingById(requestParameters: PropertyControllerGetListingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} propertyId 
     * @param {string} agentSlug 
     * @param {string} activeListing 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApiInterface
     */
    propertyControllerGetListingByIdWithAgentBrandingRaw(requestParameters: PropertyControllerGetListingByIdWithAgentBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    propertyControllerGetListingByIdWithAgentBranding(requestParameters: PropertyControllerGetListingByIdWithAgentBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get property by ID
     * @summary Get property by ID
     * @param {string} propertyId 
     * @param {string} [activeListing] Set the active listing ID for the property
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApiInterface
     */
    propertyControllerGetPropertyByIdRaw(requestParameters: PropertyControllerGetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get property by ID
     * Get property by ID
     */
    propertyControllerGetPropertyById(requestParameters: PropertyControllerGetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApiInterface
     */
    propertyControllerGetPropertyStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyStatusItemDto>>>;

    /**
     */
    propertyControllerGetPropertyStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyStatusItemDto>>;

}

/**
 * 
 */
export class PropertyApi extends runtime.BaseAPI implements PropertyApiInterface {

    /**
     */
    async propertyControllerGetAssetRaw(requestParameters: PropertyControllerGetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling propertyControllerGetAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/{filename}`;
        urlPath = urlPath.replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters['filename'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async propertyControllerGetAsset(requestParameters: PropertyControllerGetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.propertyControllerGetAssetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async propertyControllerGetListingByIdRaw(requestParameters: PropertyControllerGetListingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['listingId'] == null) {
            throw new runtime.RequiredError(
                'listingId',
                'Required parameter "listingId" was null or undefined when calling propertyControllerGetListingById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/listings/{listingId}`;
        urlPath = urlPath.replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters['listingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async propertyControllerGetListingById(requestParameters: PropertyControllerGetListingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.propertyControllerGetListingByIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async propertyControllerGetListingByIdWithAgentBrandingRaw(requestParameters: PropertyControllerGetListingByIdWithAgentBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling propertyControllerGetListingByIdWithAgentBranding().'
            );
        }

        if (requestParameters['agentSlug'] == null) {
            throw new runtime.RequiredError(
                'agentSlug',
                'Required parameter "agentSlug" was null or undefined when calling propertyControllerGetListingByIdWithAgentBranding().'
            );
        }

        if (requestParameters['activeListing'] == null) {
            throw new runtime.RequiredError(
                'activeListing',
                'Required parameter "activeListing" was null or undefined when calling propertyControllerGetListingByIdWithAgentBranding().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['activeListing'] != null) {
            queryParameters['activeListing'] = requestParameters['activeListing'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/properties/{propertyId}/agent/{agentSlug}`;
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));
        urlPath = urlPath.replace(`{${"agentSlug"}}`, encodeURIComponent(String(requestParameters['agentSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async propertyControllerGetListingByIdWithAgentBranding(requestParameters: PropertyControllerGetListingByIdWithAgentBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.propertyControllerGetListingByIdWithAgentBrandingRaw(requestParameters, initOverrides);
    }

    /**
     * Get property by ID
     * Get property by ID
     */
    async propertyControllerGetPropertyByIdRaw(requestParameters: PropertyControllerGetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling propertyControllerGetPropertyById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['activeListing'] != null) {
            queryParameters['activeListing'] = requestParameters['activeListing'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/properties/{propertyId}`;
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get property by ID
     * Get property by ID
     */
    async propertyControllerGetPropertyById(requestParameters: PropertyControllerGetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.propertyControllerGetPropertyByIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async propertyControllerGetPropertyStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyStatusItemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/properties/statuses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PropertyStatusItemDtoFromJSON));
    }

    /**
     */
    async propertyControllerGetPropertyStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyStatusItemDto>> {
        const response = await this.propertyControllerGetPropertyStatusesRaw(initOverrides);
        return await response.value();
    }

}
